/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_violin_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A wide bulge marks where values cluster; the line is the median.`)
};

const es_violin_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un abultamiento ancho marca dónde se agrupan los valores; la línea es la mediana.`)
};

const de_violin_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine breite Wölbung markiert, wo sich Werte häufen; die Linie ist der Median.`)
};

const nl_violin_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een brede uitstulping markeert waar waarden zich ophopen; de lijn is de mediaan.`)
};

const fr_violin_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un large renflement indique où les valeurs se regroupent ; la ligne est la médiane.`)
};

const it_violin_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un rigonfiamento ampio indica dove i valori si concentrano; la linea è la mediana.`)
};

const pt_br2_violin_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um alargamento largo marca onde os valores se concentram; a linha é a mediana.`)
};

const pt_violin_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma protuberância larga assinala onde os valores se concentram; a linha é a mediana.`)
};

const ja_violin_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`幅の広い膨らみは値が集中している箇所を示し、線は中央値です。`)
};

const zh_violin_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`较宽的鼓起处表示数值聚集的位置；线条为中位数。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const violin_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.violin_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("violin_ex2", locale)
	if (locale === "en") return en_violin_ex2(inputs)
	if (locale === "es") return es_violin_ex2(inputs)
	if (locale === "de") return de_violin_ex2(inputs)
	if (locale === "nl") return nl_violin_ex2(inputs)
	if (locale === "fr") return fr_violin_ex2(inputs)
	if (locale === "it") return it_violin_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_violin_ex2(inputs)
	if (locale === "pt") return pt_violin_ex2(inputs)
	if (locale === "ja") return ja_violin_ex2(inputs)
	return zh_violin_ex2(inputs)
};